var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "tab-container card" }, [
      !_vm.onlyShowAll
        ? _c("div", { staticClass: "tabs-nav" }, [
            _c("ul", { staticClass: "head" }, [
              _c(
                "li",
                {
                  staticClass: "head-item",
                  class: { current: _vm.isActiveFlag(0) },
                  on: {
                    click: function($event) {
                      _vm.setActiveFlag(0)
                    }
                  }
                },
                [_vm._v("推荐工程师")]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "head-item",
                  class: { current: _vm.isActiveFlag(1) },
                  on: {
                    click: function($event) {
                      _vm.setActiveFlag(1)
                    }
                  }
                },
                [_vm._v("符合服务的工程师")]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "head-item",
                  class: { current: _vm.isActiveFlag(2) },
                  on: {
                    click: function($event) {
                      _vm.setActiveFlag(2)
                    }
                  }
                },
                [_vm._v("全部的工程师")]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isActiveFlag(0)
        ? _c(
            "div",
            [
              _c("swb-servc-work-voucher-ds-assign-engineer-select", {
                ref: "swb_servc_work_voucher_ds_assign_engineer_select",
                attrs: {
                  voucherId: _vm.workVoucherId,
                  shopId: _vm.servicerShopId,
                  buyerShopId: _vm.retailerShopId,
                  servcId: _vm.servcId,
                  servcType: _vm.servcType,
                  ssuId: _vm.ssuId
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isActiveFlag(1) || _vm.isActiveFlag(2)
        ? _c(
            "div",
            [
              _c("swb-query-sort-area", {
                staticClass: "mb10 mt10",
                attrs: {
                  config: _vm.queryConfig,
                  queryKey: _vm.queryKey,
                  queryHandler: _vm.queryHandler
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "table-layout" },
                [
                  _c(
                    "el-table",
                    {
                      ref: "multipleTable",
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.servicerEngineerList,
                        border: "",
                        "tooltip-effect": "dark"
                      },
                      on: {
                        "current-change": _vm.handleCurrentChange,
                        "selection-change": _vm.handleSelectionChange
                      }
                    },
                    [
                      !_vm.isRadio
                        ? _c("el-table-column", {
                            attrs: {
                              align: "center",
                              type: "selection",
                              width: "55"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isRadio
                        ? _c("el-table-column", {
                            attrs: { width: "55", fixed: "left" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(rows) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "copy-radio ml15",
                                        class: {
                                          circle:
                                            _vm.selectEngineer != null &&
                                            _vm.selectEngineer.id == rows.row.id
                                        }
                                      },
                                      [_c("div", { staticClass: "circle-dot" })]
                                    )
                                  ]
                                }
                              }
                            ])
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "name", label: "工程师名称" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(rows) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(rows.row.name) + "  ")
                                ]),
                                _vm._v(" "),
                                rows.row.workState == 0
                                  ? _c(
                                      "el-tag",
                                      { attrs: { type: "success" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.workState[rows.row.workState]
                                          )
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                rows.row.workState == 1
                                  ? _c(
                                      "el-tag",
                                      { attrs: { type: "warning" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.workState[rows.row.workState]
                                          )
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                rows.row.workState == 2
                                  ? _c(
                                      "el-tag",
                                      { attrs: { type: "danger" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.workState[rows.row.workState]
                                          )
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                rows.row.servicerStaff != null
                                  ? _c("span", { staticClass: "font-red" }, [
                                      _vm._v(
                                        _vm._s(
                                          rows.row.servicerStaff.disabled
                                            ? "【禁】"
                                            : ""
                                        )
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                rows.row.signinTime != null &&
                                rows.row.signoutTime == null
                                  ? _c(
                                      "el-tag",
                                      { attrs: { type: "success" } },
                                      [_vm._v("已签到")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                rows.row.signoutTime != null
                                  ? _c(
                                      "el-tag",
                                      { attrs: { type: "danger" } },
                                      [_vm._v("已签退")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                rows.row.signinTime == null
                                  ? _c(
                                      "el-tag",
                                      { attrs: { type: "danger" } },
                                      [_vm._v("未签到")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.flag == 1 &&
                                _vm.workVoucherId != null &&
                                rows.row.metQualiFlag
                                  ? _c(
                                      "el-tag",
                                      { attrs: { type: "success" } },
                                      [_vm._v("满足资质")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.flag == 1 &&
                                _vm.workVoucherId != null &&
                                !rows.row.metQualiFlag
                                  ? _c(
                                      "el-tag",
                                      { attrs: { type: "danger" } },
                                      [_vm._v("不满足资质")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function($event) {
                                        _vm.viewStaffQuali(rows.row)
                                      }
                                    }
                                  },
                                  [_vm._v("个人资质")]
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "servicerStaff.osFlag",
                          label: "是否外协",
                          width: "80",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(rows) {
                              return [
                                !rows.row.servicerStaff.osFlag
                                  ? _c("span", [_vm._v("否")])
                                  : _c("span", [_vm._v("是")])
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "lastFlag",
                          label: "是否最近",
                          width: "80",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(rows) {
                              return [
                                rows.row.lastFlag
                                  ? _c("span", [_vm._v("是")])
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "deftFlag",
                          label: "是否默认",
                          width: "80",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(rows) {
                              return [
                                rows.row.deftFlag
                                  ? _c("span", [_vm._v("是")])
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "serveNo",
                          label: "服务工号",
                          width: "100"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "contactTel",
                          label: "联系电话",
                          width: "150"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-432642f4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-432642f4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/orgStruct/ServicerEngineerListForSelect.vue
// module id = 1926
// module chunks = 1